import { render, staticRenderFns } from "./pharmaciens.vue?vue&type=template&id=48cd485d&"
import script from "./pharmaciens.vue?vue&type=script&lang=js&"
export * from "./pharmaciens.vue?vue&type=script&lang=js&"
import style0 from "./pharmaciens.vue?vue&type=style&index=0&id=48cd485d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports